const promisesContainer = document.getElementById('promises-container');

const p_image_1 = document.querySelector('.promises__block--first');
const p_image_2 = document.querySelector('.promises__block--second');
const p_image_3 = document.querySelector('.promises__block--third');
const p_content = document.querySelector('.promises__content');

const p_depth_1 = p_image_1.getAttribute('data-depth');
const p_depth_2 = p_image_2.getAttribute('data-depth');
const p_depth_3 = p_image_3.getAttribute('data-depth');
const p_content_depth = p_content.getAttribute('data-depth');

const p_speed_1 = p_image_1.getAttribute('data-speed');
const p_speed_2 = p_image_2.getAttribute('data-speed');
const p_speed_3 = p_image_3.getAttribute('data-speed');
const p_content_speed = p_content.getAttribute('data-speed');

function promisesEffect() {
    const p_rect = promisesContainer.getBoundingClientRect();

    if (p_rect.top <= 800) {
        const mobileView = window.matchMedia('(max-width: 767px)').matches;
        const p_scrollTop = p_rect.top;

        const p_translateY_1 = p_scrollTop * p_speed_1 / p_depth_1 * 0.8;
        p_image_1.style.cssText = `
            display: flex;
            transform: translateY(${p_translateY_1}px);
        `;
        
        if (mobileView) {
            const p_translateY_2 = p_scrollTop * p_speed_2 / p_depth_2 * 0.75;
            p_image_2.style.cssText = `
                display: flex;
                transform: translateY(${p_translateY_2}px);
            `;
        } else {
            const p_translateY_2 = p_scrollTop * p_speed_2 / p_depth_2 * 0.5;
            p_image_2.style.cssText = `
                display: flex;
                transform: translateY(${p_translateY_2}px);
            `;
        }
        
        const p_translateY_3 = p_scrollTop * p_speed_3 / p_depth_3 * 0.8;
        p_image_3.style.cssText = `
            display: flex;
            transform: translateY(${p_translateY_3}px);
        `;

        const p_translateY_content = p_scrollTop * p_content_speed / p_content_depth * 0.5;
        p_content.style.cssText = `
            display: block;
            transform: translateY(${p_translateY_content}px);
        `;
    }
}

window.addEventListener('scroll', promisesEffect);
promisesEffect();
